import { Tabs } from "@shared/ui/tabs";
import AssetClassificationLanding from "./tabs/assetClassification/landing";
import DimensionsLanding from "./tabs/dimensions/landing";
import { useEffect } from "react";
import { logEvent } from "@shared/analytics/analytics";

const AssetClassification = () => {
  useEffect(() => {
    logEvent("Asset Classification Page Viewed", {});
  }, []);
  const tabComponents = {
    classification: {
      label: "Asset Classification",
      shortLabel: "Classification",
      component: <AssetClassificationLanding />,
    },
    dimensions: {
      label: "Dimensions",
      shortLabel: "Dimensions",
      component: <DimensionsLanding />,
    },
  };

  const urlMapping = {
    classification: "classification",
    dimensions: "dimensions",
  };

  return (
    <div className="p-3">
      <div className="space-y-6">
        <div className="space-y-2">
          <p className="page-title">Asset Classification</p>
          <p className="page-subtitle">
            Define and manage the hierarchical classification of assets and
            their dimensions.
          </p>
        </div>

        <Tabs
          defaultValue="classification"
          urlMapping={urlMapping}
          tabComponents={tabComponents}
          tabsListClassName="grid w-full grid-cols-2 mb-6"
          idPrefix="asset-classification-tab"
          level={0} // Top-level tabs
        />
      </div>
    </div>
  );
};

export default AssetClassification;
